import { TelemetryInit, initTelemetry } from '@workwhile/telemetry'
import { createSentryReactClient } from '@workwhile/telemetry/react'
import { config } from 'config'
import { useEffect } from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router'
import { Routes } from 'react-router-dom'

const cfg: TelemetryInit = {
  dsn: config.sentry.dsn,
  app: 'employer',
  environment: config.env,
  enabled: config.env === 'production',
  traceTargets: config.sentry.traceTargets,
  tracesSampleRate: config.sentry.tracesSampleRate,
  integrations: [
    {
      id: 'react-router',
      options: {
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
        Routes,
      },
    },
  ],
}

const client = createSentryReactClient()

initTelemetry(client, cfg)

// No exports; side-effect module by design.
export {}
